/**
 * Amplitude browser SDK bootstrap — ONY-38 / ONY-58 (tracking plan), ONY-48 (loading).
 *
 * Loaded with defer from layout/theme.liquid, after the two Amplitude CDN libraries
 * (which are also deferred). Deferred scripts run in document order, so window.amplitude
 * and window.sessionReplay are both available by the time this executes.
 *
 * IDENTITY OWNER. This key's AMP_* cookie is the single device_id/session_id for the
 * whole stack: the Shopify custom pixel (analytics/amplitude-custom-pixel.js) reads
 * `AMP_` + the first 10 characters of this key to stitch commerce and checkout events
 * onto the same Amplitude user. If this key ever changes, IDENTITY_KEY in the custom
 * pixel must change with it or identity silently splits again (ONY-33).
 */
(function () {
	'use strict';

	var AMPLITUDE_API_KEY = '5a677011dba221ae15cedfe84a31efe2';

	// Bot, dev and internal traffic are filtered at source: if any condition trips,
	// init never runs, which also means session replay never records for that visitor.
	var ua = navigator.userAgent || '';
	var isBot =
		navigator.webdriver === true ||
		/bot|crawler|spider|crawling|headless|lighthouse|slurp|bingpreview|facebookexternalhit|pingdom|gtmetrix/i.test(ua);
	var isProdHost = location.hostname === 'www.myonyra.com' || location.hostname === 'myonyra.com';

	// Phil and Crystal visit /?internal=1 once per browser to opt out permanently.
	if (/[?&]internal=1/.test(location.search)) {
		try {
			localStorage.setItem('onyra_internal', '1');
		} catch (e) {}
	}

	var isInternal = false;
	var debug = false;
	try {
		isInternal = localStorage.getItem('onyra_internal') === '1';
		// QA override: forces tracking on for preview-theme verification. Never set on a customer device.
		debug = localStorage.getItem('onyra_amp_debug') === '1';
	} catch (e) {}

	if ((isBot || !isProdHost || isInternal) && !debug) return;

	if (!window.amplitude || !window.sessionReplay) return;

	// sampleRate unchanged at 1 — Phil's recorded decision, 2026-08-04 (ONY-48).
	// No privacyConfig: plugin defaults are deliberately left in place (ONY-48).
	window.amplitude.add(window.sessionReplay.plugin({ sampleRate: 1 }));

	window.amplitude.init(AMPLITUDE_API_KEY, {
		autocapture: {
			pageViews: true,
			sessions: true,
			attribution: true,
			formInteractions: false, // unattributable noise — ONY-33 §7
			fileDownloads: false,
			elementInteractions: false,
		},
	});
})();
